import styled from 'styled-components'

export const IdeaSelectWrapper = styled.div`
	margin-bottom: 16px;
`
